import React from 'react';
import type { IssueSummary } from '@chatsdet/types/issues';
import { EditableBadge, type EditableBadgeOption, type BadgeProps } from '@chatsdet/ui';
import { useUpdateIssueSeverityMutation } from '../../../hooks/useIssuesV2';
import { issueSeverityBadgeVariants, formatSeverityLabel } from './issueBadges';

type IssueSeverity = IssueSummary['severity'];

const severityOptions: EditableBadgeOption<IssueSeverity>[] = [
  { id: 'high', label: 'HIGH' },
  { id: 'medium', label: 'MEDIUM' },
  { id: 'low', label: 'LOW' },
  { id: 'unknown', label: 'UNKNOWN' },
];

interface SeverityEditableBadgeProps {
  issue: IssueSummary;
  onSuccess?: () => void;
  size?: BadgeProps['size'];
}

export function SeverityEditableBadge({ issue, onSuccess, size }: SeverityEditableBadgeProps) {
  const mutation = useUpdateIssueSeverityMutation(issue.id);

  const handleChange = (severity: IssueSeverity) => {
    mutation.mutate(severity, { onSuccess });
  };

  return (
    <EditableBadge
      value={issue.severity}
      options={severityOptions}
      onChange={handleChange}
      getVariant={(value) => issueSeverityBadgeVariants[value]}
      formatLabel={formatSeverityLabel}
      size={size}
      isLoading={mutation.isPending}
      aria-label={`Change severity for issue: ${issue.title}`}
    />
  );
}
